import React, { Component } from 'react';

import '../Nav/Nav.css';

class Nav extends Component {

    constructor() {
        super()
        
        this.state = {
          toggle: false
        }
      }

    sidebar=()=>{
        
        this.setState({toggle: !this.state.toggle});
        
      } ;
  render() {
   

    return (
      <div >
                <nav className={this.state.toggle === false ?"menu-opener":"menu-opener active"} onClick={this.sidebar}>
                <div className={this.state.toggle === false ?"menu-opener-inner":"menu-opener-inner active"}></div>
            </nav>
            <nav  className={this.state.toggle === false ?"menu":"menu active"}>
                <ul className="menu-inner">
                <a href="#home" className="menu-link " >
                    <li>Home</li>
                </a>
                <a href="#about" className="menu-link">
                    <li>About</li>
                </a>
                <a href="#portfolio" className="menu-link">
                    <li>Portfolio</li>
                </a>
                <a href="#resume" className="menu-link">
                    <li>Resume</li>
                </a>
                <a href="#contact" className="menu-link">
                    <li>Contact</li>
                </a>
                </ul>
            </nav>
      </div>
    );
  }
}

export default Nav;
